<script setup lang="ts">
import { GlobalProvider } from '@mrbilit/vue-context-provider';
import useLayout from './layouts/useLayout';
const { mobileNavBlackList } = useLayout();
const { loadPostHog } = usePostHog();
const runEnv = useRunEnv();
onBeforeMount(() => {
    useRatingModal();
    loadPostHog();
});
useRobots();
useYektanet();
useHead({
    meta: [
        { property: 'og:image:width', content: '512' },
        { property: 'og:image:height', content: '512' },
    ],
});

const MobileNav = defineAsyncComponent(
    () => import('@components/layout/mobile/MobileNav.vue')
);

const BottomSheetsContainer = defineAsyncComponent(
    () => import('@components/base/mr-modal/BottomSheetsContainer.vue')
);

const PageOverlayProvider = defineAsyncComponent(
    () => import('./composables/pageOverlayHandler/PageOverlayProvider.vue')
);

const ModalsContainer = defineAsyncComponent(async () => {
    const val = await import('vue-final-modal');
    return val.ModalsContainer;
});

const nuxtApp = useNuxtApp();
if (runEnv !== 'prod') {
    nuxtApp.hook('vue:error', (error, instance, info) => {
        console.log('[Vue Error]', { error, instance, info });
    }); // Nuxt app-level errors
    nuxtApp.hook('app:error', error => {
        console.log('[App Error]', error);
    });
}
</script>

<template>
    <GlobalProvider>
        <NuxtLayout>
            <main>
                <NuxtPage />
            </main>
        </NuxtLayout>
        <Transition name="mobile-nav">
            <MobileNav v-if="!mobileNavBlackList" />
        </Transition>
        <ClientOnly>
            <ModalsContainer />
            <BottomSheetsContainer />
            <PageOverlayProvider />
        </ClientOnly>
    </GlobalProvider>
</template>

<style scoped lang="scss">
$duration: 200ms;

.mobile-nav-leave-active {
    animation: $duration leave-animation;
}

.mobile-nav-enter-active {
    animation: $duration enter-animation;
}

@keyframes enter-animation {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes leave-animation {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(100%);
    }
}
</style>
